<template>
	<div>
		<paginated-search v-bind="{ schema, searchEntities, openEntity, autoEnable: true }"></paginated-search>

		<modal v-if="showModal" @close="showModal = false">
			<template slot="body">
				<md-toolbar :md-elevation="1" class="md-accent">
					<span class="md-display-1">{{entity.pageName}}</span>
				</md-toolbar>

				<md-list class="md-double-line">
					<md-subheader>Usuário</md-subheader>

					<md-list-item>
					<md-icon class="md-primary">person</md-icon>

					<div class="md-list-item-text">
						<span>{{entity.user.name}}</span>
						<span v-if="entity.user.company">{{entity.user.company.name}}</span>
						<span v-else>Sem empresa</span>
					</div>
					</md-list-item>

					<md-list-item>
					<md-icon class="md-primary">email</md-icon>

					<div class="md-list-item-text">
						<span>{{entity.user.email}}</span>
					</div>
					</md-list-item>

					<md-divider></md-divider>
					<md-subheader>Comentário</md-subheader>

					<md-card-content>
						{{entity.comment}}
					</md-card-content>


				</md-list>
			</template>
			<template slot="footer">
				<md-button class="md-danger" @click="showModal = false">Fechar</md-button>
			</template>
		</modal>
	</div>
</template>

<script>
	import { Modal } from '@/components'
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import Contact from "@/models/contact.model.vue";

	export default {
		components: {
			PaginatedSearch,
			Modal,
		},
		data () {
			return {
				schema: Contact.getSchema(),
				showModal: false,
				entity: {},
			};
		},
		methods: {
			async openEntity(entity) {
				this.entity = Object.assign(entity, await Contact.getInfo(entity.id));
				this.showModal = true;
			},
			async searchEntities(paginationParameters) {
				return Contact.search(paginationParameters);
			},
		},
	}
</script>
